import { useState, useEffect } from 'react';
import { ChatBotTemplate } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';
import { useEditorStore } from '~/shell/Store';

export const useChatBotTemplates = () => {
  const [templates, setTemplates] = useState<ChatBotTemplate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { apiService } = useEditorStore();

  useEffect(() => {
    const fetchTemplates = async () => {
      if (!apiService) {
        setError('API service not available');
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await apiService.getChatBotTemplates();

        if (response.error) {
          setError(response.message || 'Failed to fetch templates');
          return;
        }

        const transformedTemplates: ChatBotTemplate[] = response.map(
          (template: {
            id: string | number;
            text?: string;
            description?: string;
          }) => ({
            id: String(template.id),
            name: template.text || `Template ${template.id}`,
            description: template.description
          })
        );

        setTemplates(transformedTemplates);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : 'Failed to fetch templates'
        );
        console.error('Error fetching chatbot templates:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, [apiService]);

  return {
    templates,
    loading,
    error,
    hasMultipleTemplates: templates.length > 1
  };
};
